module.exports = __webpack_public_path__ + "createstatic/media/default.27f0f99e.jpg";